<!-- Customer Navigation -->
<div class="surface-0 shadow-1 px-4 py-3 mb-3 cr-customer-sticky-header">

    <div class="flex justify-content-between gap-2">
        <!--       left side of the header-->

        <div class="flex gap-2 w-full align-items-center">
            <div class="mr-2" pTooltip="EndUser WebApp" tooltipPosition="bottom">
                <!--        [disabled]="!customerDto?.lastLoginDevice"-->
                <!--        class="{{!customerDto?.lastLoginDevice ? 'h-max block disabled-user' : ''}}"-->
                <p-button
                        (click)="openProxyWebAppLogin()"
                        [loading]="false"
                        [disabled]="busy"
                        [icon]="busy ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-screen-users'"
                        [text]="true"
                        styleClass="border-1 border-400 text-xl">
                </p-button>
            </div>
            <div class="flex gap-2 align-items-center">
                <ng-container *ngIf="customerDto">
                    <div class="mr-5 flex align-items-center gap-3">
                        <div>
                            <h5 class="mb-0 font-bold">{{ customerDto.personDtoName }}</h5>
                            <small>{{ customerDto.alias }}</small>
                        </div>

                        <!-- Zahlstatus chip, between the name and the household persons. -->
                        <cr-customer-payment-status
                                [customerId]="customerId">
                        </cr-customer-payment-status>

                        <!-- legalsub (OD-19): display only - no click into the person drawer. -->
                        <mvs-cr-customer-representative-badge
                                [customerId]="customerId"
                                [interactive]="false">
                        </mvs-cr-customer-representative-badge>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="customerDto">

                <customer-person-household-persons
                        [customerId]="customerId"></customer-person-household-persons>

            </div>


        </div>

        <!--        right side of the header -->

        <div class="flex align-items-center gap-2">

            @if (customerDto && customerDto.customerExternalAlias?.length) {
                <div class="flex align-items-center border-1 px-3 border-400 border-round cursor"
                     (click)="overlayExternal.toggle($event)"
                     style="height: 3.4rem">
                    @for (system of uiExternalAlias; track system.systemDtoId) {
                        <i class="{{system.systemDto.image}} text-{{system.systemDto.rgbaColor}} fa-2xl"
                           style="line-height:normal"></i>
                    }
                </div>
            }

            @if (customerDto && (customerDto.lastSuccessfulCall || customerDto.lastLoginDevice)) {
                <div class="flex align-items-center border-1 px-3 border-400 border-round cursor"
                     style="height: 3.4rem"
                     (click)="contractLogin.toggle($event)">

                    @if (customerDto.lastSuccessfulCall) {
                        <div class="flex gap-2 align-items-center" pTooltip="Letztes Gespräch"
                             tooltipPosition="top">
                           <span class="border-circle text-green-500 flex justify-content-center align-items-center">
                               <i class="fa-solid fa-phone-volume"></i>
                           </span>
                            <span class="text-600">{{ customerDto.lastSuccessfulCall.startTime | date:'dd.MM.yyy' }}</span>
                        </div>
                    }

                    <p-divider *ngIf="customerDto.lastSuccessfulCall && customerDto.lastLoginDevice"
                               styleClass="mx-3" layout="vertical"/>

                    @if (customerDto.lastLoginDevice) {
                        <div class="flex gap-2 align-items-center pr-2" pTooltip="Last Login" tooltipPosition="top">
                            <i
                                    class="{{ customerDto.lastLoginDevice.deviceTypeEnumImage || 'fa-light fa-mobile-button'}} text-blue-500 text-lg"></i>
                            <span class="text-600">{{ customerDto.lastLoginDevice.lastModifiedDate | date:'dd.MM.yyyy' }}</span>
                        </div>
                    }

                </div>
            }

            <div class="flex align-items-center border-1 border-400 border-round" style="height: 3.4rem">


                <div class="px-3 py-1 cursor hover:surface-hover cursor-pointer" (click)="createTicket()"
                     tooltipPosition="top"
                     pTooltip="Ticket erstellen">
                    <i class="fa-regular fa-ticket text-xl text-blue-400 bg-blue-100 p-2 border-round"></i>
                </div>

            </div>

        </div>

    </div>
</div>

<p-popover #overlayExternal [style]="{ width: '27rem'}">


    <h5 class="pl-2">External Partners</h5>


    @if (uiExternalAlias && uiExternalAlias.length) {
        <div class="flex flex gap-3 flex-column">
            @for (item of uiExternalAlias; track item.systemDtoId) {
                <div class="flex align-items-center justify-content-between gap-2">
                    <div class="flex gap-2 w-full">
                        <i class="{{item.systemDto.image}} text-6xl text-{{item.systemDto.rgbaColor}}"></i>
                        <div class="flex gap-1 flex-column w-full">
                            <div class="flex gap-1 justify-content-between">

                                <div class="flex gap-1 flex-column text-color-secondary">
                                    <span class="text-lg">User:</span>
                                    <span class="">{{ item.systemDto.name }}</span>
                                </div>

                                <div class="flex gap-1 flex-column">

                                    @for (alias of item.uiAliasList; track alias) {
                                        <div class="flex align-items-center gap-2">
                                            <span class="font-medium text-xl pl-3">
                                                {{ alias }}
                                            </span>

                                            <!-- Link only when the environment maps this system to a consultant app. -->
                                            @if (externalSystemTargets[item.systemDtoId]) {
                                                <i class="fa-solid fa-arrow-up-right-from-square text-primary cursor-pointer"
                                                   title="Im System öffnen"
                                                   (click)="openExternalSystemCustomer(item.systemDtoId, alias)">
                                                </i>
                                            }
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    }
</p-popover>

<p-popover #contractLogin class="w-25rem">

    <h5>Letztes Gespräch</h5>

    @if (customerDto && customerDto.lastSuccessfulCall) {
        <!--  Last Successfull call  -->
        <div class="shadow-1 card flex flex-column gap-1 mb-2">
            <div class="mb-2">
                <span class="text-600">{{ customerDto.lastSuccessfulCall.startTime | date:'dd.MM.yyyy, HH:mm' }}</span>
            </div>

            <div class="font-medium">{{ customerDto.lastSuccessfulCall.callTypeDtoName }}</div>
            <span class="text-600 mb-2">Gesprächsdauer: {{ formattedDuration }}</span>

            <div class="flex align-items-center gap-2">
                <mvs-form-control-output-user-image
                        [value]="customerDto.lastSuccessfulCall.createdBy"></mvs-form-control-output-user-image>

                <span class="text-600">{{ customerDto.lastSuccessfulCall.agentDtoName }}</span>
            </div>

        </div>
    }

    @if (customerDto && customerDto.lastLoginDevice) {
        <!--    Last Login -->
        <div class="shadow-1 card flex flex-column gap-2 mb-2">
            <div class="flex justify-content-between gap-2 align-items-center mb-2">
            <span
                    class="border-round text-blue-500 bg-blue-100 history-icon flex justify-content-center align-items-center">
              <i class=" {{ customerDto.lastLoginDevice.deviceTypeEnumImage || 'fa-light fa-mobile-button' }}"></i>
          </span>
                <span class="text-600">{{ customerDto.lastLoginDevice.lastModifiedDate | date:'dd.MM.yyyy, HH:mm' }}</span>
            </div>

            <div class="flex justify-content-between align-items-center mb-2">
                <span class="text-600">Device</span>
                <span class="text-700">{{ customerDto.lastLoginDevice.deviceTypeEnumName }}</span>
            </div>

        </div>
    }

</p-popover>


